import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';
import IndexH5 from './indexH5';
import IndexPc from './indexPc';
export default function ImgTextB() {
    const { useLang, isMobile, useEffect } = useGlobal();
    const { t } = useLang('dualfuelsmartgenerator');
    const Com = isMobile ? <IndexH5 /> : <IndexPc />;

    let controller: any;
    useEffect(() => {
        controller = new ScrollMagic.Controller();
    }, []);

    // 手机动画
    useEffect(() => {
        if (isMobile) {
        }
    }, []);

    return <div className={`dg200ImgTextB ${css.dg200ImgTextB} ${isMobile ? 'dg200ImgTextB_h5' : 'dg200ImgTextB_pc'}`}>{Com}</div>;
}
